import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
import api from '../../api/api';
import { Player, Team, Position, Match, Game, SimplePlayer, MatchWithRanks,Placing, PlacingWithCaptainVice, SCTeam, LightPlayer, PlacingWithChange, PartnerShip } from '../../types/types';

export interface SinglePlayerState {
    singlePlayer: {
        player: Player;
        games: Game[];
        matches: Match[];
        upcoming: MatchWithRanks[];
        partnerShips: PartnerShip[];
        stats: {
          be: number;
          nv: number;
          last5: number[];
          three: number|string;
          five: number|string;
          avgpts: number;
          avgbase: number;
          aveppm: number;
        };
    }
    status: 'idle' | 'loading' | 'failed';
}

export interface SinglePlayerAction {
    player: Player; 
    games: Game[];
    matches: Match[];
    upcoming: MatchWithRanks[];
    partnerShips: PartnerShip[];
    stats: {
      be: number;
      nv: number;
      last5: number[];
      five: string|number;
      three: string|number;
      avgpts: number;
      avgbase: number;
      aveppm: number;
    };
}

export interface SinglePlayerPayload { 
    type: String,
    payload: { player: Player, games: Game[], stats: object}
  }

const initialState: SinglePlayerState = {
    singlePlayer: {
        player: {id: "-1", firstname: "", lastname: "", pic: '', position: {name: ""}, stats: [{last5Games: [], timestamp: "", avgpts: 0, avgbase:0, ppm: 0}], positionrank: [],ownerships: [], partnerShips: [], overs: [], positions: [], dismissals: []},
        games: [],
        matches: [],
        upcoming: [],
        stats: {
          be: -1,
          nv: -1,
          last5: [],
          three: -1,
          five: -1,
          avgpts: 0, 
          avgbase:0,
          aveppm: 0,
        }
      },
      status: "idle"
}


const fetchSinglePlayer = (id?:string) => {
    return new Promise<{data: SinglePlayerAction}>((resolve) => {
      api.get('/player/'+id).then(function(payload) {
        resolve(payload);
      });
    });
}

export const GetSinglePlayer = createAsyncThunk(
    'front/getsingleplayer',
    async (id?:string) => {
        const response = await fetchSinglePlayer(id);
        return response;
    }
);



export const singlePlayerSlice = createSlice({
    name: "singleplayer",
    initialState,
    reducers: {
      getsingleplayer: (state, action) => {
  
      }
    },
    extraReducers: (builder) => {
      builder
        .addCase(GetSinglePlayer.pending, (state) => {
          state.status = 'loading';
        })
        .addCase(GetSinglePlayer.fulfilled, (state, action) => {
          state.status = 'idle';
          state.singlePlayer = action.payload.data
        });
  
    }
})

export const selectSinglePlayerLoading = (state: RootState) => state.singleplayer.status;

export const selectSinglePlayer = (state: RootState) => state.singleplayer.singlePlayer;

export const selectUpcoming = (state: RootState) => state.singleplayer.singlePlayer.upcoming;

export const { getsingleplayer } = singlePlayerSlice.actions

export default singlePlayerSlice.reducer;